/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Setup_Tab_OperationsInputs */

const en_setup_tab_operations = /** @type {(inputs: Setup_Tab_OperationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Operations`)
};

/**
* | output |
* | --- |
* | "Operations" |
*
* @param {Setup_Tab_OperationsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const setup_tab_operations = /** @type {((inputs?: Setup_Tab_OperationsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Setup_Tab_OperationsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_setup_tab_operations(inputs)
});